import { EVENT_TEMPLATE_ON_DAY_CHECK_IN, EVENT_TEMPLATE_ON_DAY_CHECK_OUT, EVENT_TEMPLATE_ON_DAY_ROOM_CHANGE } from "utilities/entities/accommodation/event-template-utilities";
import useAppContext from "utilities/hooks/useAppContext";

type EventTemplateOnDayViewPropsType = {
    onDay: number;
    repeat: boolean;
}

const EventTemplateOnDayView = (props: EventTemplateOnDayViewPropsType) => {
    const context = useAppContext();
    let day = props.repeat ? context.t('accommodation.eventTemplate.everyDay') : context.t('accommodation.eventTemplate.on');
    switch (props.onDay) {
        case EVENT_TEMPLATE_ON_DAY_CHECK_IN:
            day = day.replace('{day}', context.t('accommodation.eventTemplate.checkIn').toLowerCase());
            break;
        case EVENT_TEMPLATE_ON_DAY_CHECK_OUT:
            day = day.replace('{day}', context.t('accommodation.eventTemplate.checkOut').toLowerCase());
            break;
        case EVENT_TEMPLATE_ON_DAY_ROOM_CHANGE:
            day = day.replace('{day}', context.t('accommodation.eventTemplate.roomChange').toLowerCase());
            break;
        case 1:
            day = day.replace('{day}', '');
            break;
        default:
            day = day.replace('{day}', props.onDay.toString());
            break;
    }

    return <>{day}</>;
};

export default EventTemplateOnDayView;
